import APIServiceLookUp from './serviceAPI';
import { API_URL } from './models/AppConstent';

export default class ServiceCourse {
    lookupService = new APIServiceLookUp();

    async getAllCourse(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}course/getAllCourse`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async setCourse(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}course/setCourse`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async updateCourse(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}course/updateCourse`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async delCourse(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}course/delCourse`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

}
